<script setup>
import {getCurrentInstance, ref} from "vue";

const app = getCurrentInstance().proxy;
const props = defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
  read: {
    type: Boolean,
    default: false,
  }
});


const emit = defineEmits(["onSuccess", "close"]);
const agreeProtocol = ref(false)

const agreeLoading = ref(false);
const refuseLoading = ref(false);

const agreeProtocolAction = () => {
  if (agreeProtocol.value) {
    agreeLoading.value = true
    apiSetAgreeProtocol(1)
  } else {
    app.$message.error('请先阅读协议并同意');
  }
}

const refuseProtocolAction = () => {
  refuseLoading.value = true
  apiSetAgreeProtocol(-1)
}

/**
 * 协议操作请求
 * @param status
 */
const apiSetAgreeProtocol = (status) => {
  app.$axios
    .get(app.$api.preferred_supplychain.setProtocolAgree, {
      params: {auditStatus: status},
    })
    .then((res) => {
      agreeLoading.value = false
      refuseLoading.value = false
      if (res.code === 0) {
        app.$message.success('操作成功');
        emit('onSuccess');
      }
    });
}

const close = () => {
  emit("close");
};

</script>

<template>
  <el-dialog
    title="供应链合作协议"
    :visible.sync="isShow"
    width="850px"
    :before-close="close"
  >
    <div>
      <div class="container-protocol">
        <iframe height="100%" width="100%" src="https://wsnbh.oss-cn-hangzhou.aliyuncs.com/pdf/%E5%95%86%E5%AE%B6%E4%BE%9B%E5%BA%94%E9%93%BE%E5%90%88%E4%BD%9C%E5%8D%8F%E8%AE%AE.pdf">

        </iframe>
      </div>

      <el-checkbox
        v-model="agreeProtocol" style="margin-top: 12px" v-if="!read">
        我已认真阅读并同意协议内容
      </el-checkbox>

      <div class="btns-protocol" v-if="!read">
        <el-button :loading="refuseLoading" @click="refuseProtocolAction">拒绝合作</el-button>
        <el-button type="primary" :loading="agreeLoading" @click="agreeProtocolAction">同意合作</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped>
.container-protocol {
  border: 1px solid #C3272C;
  height: 600px;
  border-radius: 4px;
}

.btns-protocol {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
